import { render } from "./ChatGPT.vue?vue&type=template&id=6e80af99"
import script from "./ChatGPT.vue?vue&type=script&lang=js"
export * from "./ChatGPT.vue?vue&type=script&lang=js"

import "./ChatGPT.vue?vue&type=style&index=0&id=6e80af99&lang=css"

import exportComponent from "E:\\newyear\\chatgpt\\chat-bot-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__